import styled from 'styled-components';
import { Breakpoint, FontSize, FontWeight } from '../../styles/constants';
import { H4 } from '../Typography/Heading/Heading.styles';
import { Paragraph } from '../Typography/Paragraph/Paragraph';
import { DisplayCard } from '../cards/DisplayCard/DisplayCard';

export const PathwayCard = styled(DisplayCard)`
  display: inline-flex;
  flex: 1;
  height: 182px;
  width: 163px;

  ${Breakpoint.SMALL} {
    height: auto;
    width: auto;
  }
`;

export const PathwayIconWrapper = styled.div`
  height: 36px;
  margin-bottom: 12px;
  width: 36px;
`;

export const PathwayTitle = styled(H4)`
  color: inherit;
  font-size: ${FontSize.LARGE};
  font-weight: ${FontWeight.SEMI_BOLD};
  margin-bottom: 4px;

  ${Breakpoint.SMALL} {
    font-size: ${FontSize.LARGE};
    margin-bottom: 4px;
  }
`;

export const PathwaySubTitle = styled(Paragraph)`
  color: inherit;
`;
